import { render, staticRenderFns } from "./vExportLabelButtons.vue?vue&type=template&id=22f935a7"
import script from "./vExportLabelButtons.vue?vue&type=script&lang=ts"
export * from "./vExportLabelButtons.vue?vue&type=script&lang=ts"
import style0 from "./vExportLabelButtons.vue?vue&type=style&index=0&id=22f935a7&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports